import { usePathname } from 'next/navigation';

export function useNormalizePathname(): string {
  const pathname = usePathname();
  return pathname.replace(/^\/[a-z]{2}(\/|$)/, '/');
}
